import React from "react";
import { useLocation } from "react-router-dom";
import { getDecodedToken, hasPermission, canOpenPage, PAGE_PREFIX } from "../helpers/auth";
import { NAV_SECTIONS } from "./main-layout";
import NotAuthorizedPage from "./not-authorized";

// every menu page (path → its module key), longest path first so /client-360 wins over /clients
const MENU_PAGES = NAV_SECTIONS.flatMap((s) => s.items).filter((i) => !i.alwaysVisible && !i.superAdminOnly)
  .sort((a, b) => b.path.length - a.path.length);

const ProtectedRoute = ({ children, permKey, superAdminOnly }) => {
  const token = getDecodedToken();
  const { pathname } = useLocation();

  if (!token || token.role !== 2) return <NotAuthorizedPage />;

  if (superAdminOnly && token.roleId) return <NotAuthorizedPage />;

  if (token.roleId) {
    // roles with page-level access: only the pages given on the Roles page
    let perms = [];
    try { perms = JSON.parse(localStorage.getItem("cyt_permissions") || "[]") || []; } catch { perms = []; }
    const pageMode = Array.isArray(perms) && perms.some((x) => String(x).startsWith(PAGE_PREFIX));
    if (pageMode) {
      const page = MENU_PAGES.find((i) => pathname === i.path || pathname.startsWith(`${i.path}/`));
      if (page && !canOpenPage(page.path, page.permKey)) return <NotAuthorizedPage />;
      if (!page && permKey && !hasPermission(permKey)) return <NotAuthorizedPage />;
      return children;
    }
  }

  if (permKey && !hasPermission(permKey)) return <NotAuthorizedPage />;

  return children;
};

export default ProtectedRoute;
